module.exports = __webpack_public_path__ + "static/media/vitez.36f568da.jpg";